import { ValidatorFn, AbstractControl, FormGroup, ValidationErrors, AsyncValidatorFn } from '@angular/forms';
import PhoneNumber from 'awesome-phonenumber';
import { map, catchError } from 'rxjs/operators';
import { of, Observable } from 'rxjs';
import { OrganizationResource } from '@apaq/orgkit-js';

export class CustomValidators {
    public static phone(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (control.value == null || control.value === '') {
                return null;
            }
            const pn = new PhoneNumber(control.value);
            const forbidden = !pn.isValid();
            return forbidden ? { phone: { value: control.value } } : null;
        };
    }

    public static accountingSystem(organizationService: OrganizationResource): AsyncValidatorFn {
        return (control: AbstractControl): Promise<ValidationErrors | null>  => {
            const system = control.get('accountingSystem')?.value;
            const id = control.get('accountingSystemId')?.value;
            const key = control.get('accountingSystemKey')?.value;

            if (system === null || system === '' || system === 'None' || key === null || key === '') {
                return Promise.resolve(null);
            }

            return Promise.resolve({ accountingSystemKey: { value: key.value } });
            /*return organizationService.checkAccountingConnection({ id, key, system }).pipe(map(result => {
                return null;
            }), catchError(_ => of({ 
                accountingSystemKey: { value: key.value } }
                ))).toPromise(); // , catchError(_ => of({ accountingSystemKey: { value: key.value } }))));*/
        };
    }
}